import { UserService } from './../../service/user.service';
import { album } from './../../models/album.model';
import { media } from './../../models/media.model';
import { Component, OnInit } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the BuyStep2Page page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-buy-step2',
  templateUrl: 'buy-step2.html',
})
export class BuyStep2Page implements OnInit {

  public media: media;
  public album: album;

  public title: string;
  public price: number;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private uService: UserService
    ) {
  }

  ngOnInit(){
    if (this.navParams.get("album"))
    {
      this.album = this.navParams.get("album");
      this.title = this.album.title;
      this.price = this.album.price;
    }
    else
    {
      this.media = this.navParams.get("media");
      this.title = this.media.title;
      this.price = this.media.price;
    }
  }

  BuyCreditCard(){
    alert("Köp med kreditkort - " + this.uService.user.id);
  }

  BuyCode(){
    alert("Köp med förbetald kod - " + this.uService.user.id);
  }

}



// WEBPACK FOOTER //
// ./src/pages/buy-step2/buy-step2.ts